import { Navigate, useParams } from "react-router-dom"

export  const PreSelectTenant = () => {   
    const { tenantId } = useParams();    
    return Navigate({to: '/tenants/' + tenantId, replace: true})
}